import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

// Types
import type { CartItem } from '@white-label-types/parking-checkout';

// Components
import ExpansionPanel from '../expansion-panel/expansion-panel.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'payment-policies',
  props: {
    cancellationPolicies: { default: () => [] },
    amendmentPolicies: { default: () => [] }
  },
  setup(__props: any) {

const props = __props as { cancellationPolicies: CartItem['inventory_option']['cancellation_policies'], amendmentPolicies: CartItem['inventory_option']['amendment_policies'] };

// Packages


const hasCancellationPolicies = computed(() => props.cancellationPolicies.length);
const hasAmendmentPolicies = computed(() => props.amendmentPolicies.length);
const hasCancellationOrAmendmentPolicies = computed(
  () => hasCancellationPolicies.value || hasAmendmentPolicies.value
);

return { __sfc: true,props, hasCancellationPolicies, hasAmendmentPolicies, hasCancellationOrAmendmentPolicies, ExpansionPanel }
}

})